import React from 'react';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import PreLoginPage from '../../../views/core/PreLoginPage';
import spl1 from '../../../images/icons/SPL/spl1.png';
import spl2 from '../../../images/icons/SPL/spl2.png';
import spl3 from '../../../images/icons/SPL/spl3.png';
import spl4 from '../../../images/icons/SPL/spl4.png';
import plp1 from '../../../images/icons/PLP/plp1.png';
import plp2 from '../../../images/icons/PLP/plp2.png';
import plp3 from '../../../images/icons/PLP/plp3.png';
import plp4 from '../../../images/icons/PLP/plp4.png';

// ES6 class-style
class OverallFeatures extends PreLoginPage {
    constructor(props) {
        super(props);
        this.loadFeature=this.loadFeature.bind(this);
    };

componentDidMount(){
    //console.log("Overall Features ",this.props)
}

SPL(){
    return(
        <div id="OverallFeatures" className="spl-features">
		<div className="container">			
			<div className="row">
			    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={spl1} alt="Book of stories" />
                    <h3 className="heading-three">Stories</h3>
                    <p>Our rich animated stories explain the ‘why’ and ‘how’ of every Maths concept and really engage students.</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={spl2} alt="Student learning vocabulary" />
                    <h3 className="heading-three">Vocabulary</h3>
                    <p>Language and voice in our lessons build comprehension skills; which is important for solving word problems</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={spl3} alt="List of interactive tasks" />
                    <h3 className="heading-three">Activities</h3>
                    <p>Interactive tasks with immediate feedback helps students check their understanding and develop confidence.</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={spl4} alt="Singapore Flag" />
                    <h3 className="heading-three">Enrichment</h3>
                    <p>Proven teaching approaches from Singapore’s world class education system deepen mathematical thinking.</p>
                </div>
            </div>
		</div>
	</div>
    )
}
   
PLP(){
    return(
        <div id="OverallFeatures">
		<div className="container">			
			<div className="row">
			    <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={plp1} alt="Diagnostic test report" />
                    <h3 className="heading-three">Take mini tests</h3>
                    <p>Choose a topic and take a series of diagnostic tests to assess your proficiency.</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={plp2} alt="Video lesson" />
                    <h3 className="heading-three">Watch videos</h3>
                    <p>We will recommend lessons that will help you bridge learning gaps.</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={plp3} alt="Man holding bow and arrow" />
                    <h3 className="heading-three">Complete practice</h3>
                    <p>We will also recommend targeted practice to help improve your scores</p>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-3 featureSection">
                    <img src={plp4} alt="Granular report card" />
                    <h3 className="heading-three">Performance summary</h3>
                    <p>To identify specific topics and problems to focus on to achieve mastery</p>
                </div>
            </div>
		</div>
	</div>
    )
}

loadFeature(){
    if(this.props.name=="SPL"){
        return this.SPL();
    }else{
        return this.PLP();
    }
}

render() {
  	return (
          this.loadFeature()
      )
}
}

export default OverallFeatures;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/OverallFeatures.js